import { add } from 'date-fns'

import { SESSION_ACTIVE, SESSION_EOL, SESSION_UNINITIALISED, STORAGE_KEY } from '@/config/constants'
import { DateTimeHelper } from '@/helpers/DateTime'
import { LogHelper } from '@/helpers/Log'

const color = 'color: yellow'

class Session {
  constructor() {
    this.key = STORAGE_KEY
    this.session = null
    this.status = SESSION_UNINITIALISED
  }

  clear() {
    const basketId = this.session?.basketId

    this.session = null
    this.status = SESSION_UNINITIALISED

    if (basketId) {
      LogHelper.info(['%cCLEARED SESSION', color, basketId])
    }

    window.localStorage.removeItem(this.key)

    return Promise.resolve()
  }

  resume(getBasket) {
    return this.get()
      .catch(() => {
        return this.clear().then(() => {
          throw new Error('No session in localstorage found')
        })
      })
      .then(session => getBasket(session))
      .then(basket => this.set(basket))
      .then(basket => {
        LogHelper.info(['%cRESUMED SESSION', color, basket.basketId])
        return basket
      })
  }

  set(payload) {
    if (!this.key) return Promise.reject()

    const { basketId, jwToken, updateDate } = payload
    this.session = { basketId, jwToken, updateDate }
    this.status = SESSION_ACTIVE

    // log basketId to instana
    if (window.ineum) {
      window.ineum('user', basketId)
    }

    const session = { ...this.session }
    if (!payload.email || !payload.mobile) {
      session.eol = add(new Date(), SESSION_EOL)
    }

    window.localStorage.setItem(this.key, JSON.stringify(session))
    return Promise.resolve(payload)
  }

  start(createBasket, payload) {
    return createBasket(payload)
      .then(basket => this.set(basket))
      .then(basket => {
        LogHelper.info(['%cCREATE SESSION', color, basket.basketId])
        return basket
      })
      .catch(error => {
        LogHelper.warn(['%cFAILED TO CREATE SESSION', color, error])
        throw error
      })
  }

  isActive() {
    return this.status === SESSION_ACTIVE
  }

  /**
   * if existent and eol not in past, return saved session-details
   * @return {Promise}
   */
  get() {
    const item = window.localStorage.getItem(this.key)
    let value
    try {
      value = item && JSON.parse(item)
    } catch (e) {
      LogHelper.error(['Failed to get session from localstorage\n', e, item])
    }

    if (!value || (value && value.eol && !DateTimeHelper.isInFuture(new Date(value.eol)))) {
      return Promise.reject()
    } else {
      return Promise.resolve({ ...value })
    }
  }
}

export default {
  install(Vue) {
    Vue.prototype.$session = new Session()
  },
}
